import React from 'react';

export default () => (
  <svg width="25" height="22" viewBox="0 0 25 22" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M5.92857 5.92857L10.8571 10.8571L5.92857 15.7857M13.3214 15.7857H19.8929M2.64286 1H22.3571C22.7929 1 23.2107 1.17309 23.5188 1.48118C23.8269 1.78928 24 2.20714 24 2.64286V19.0714C24 19.5071 23.8269 19.925 23.5188 20.2331C23.2107 20.5412 22.7929 20.7143 22.3571 20.7143H2.64286C2.20714 20.7143 1.78928 20.5412 1.48118 20.2331C1.17309 19.925 1 19.5071 1 19.0714V2.64286C1 2.20714 1.17309 1.78928 1.48118 1.48118C1.78928 1.17309 2.20714 1 2.64286 1Z" stroke="currentColor" strokeWidth="1.5" />
  </svg>
);
